import { z } from 'zod'

export const authSchema = z.object({
  email: z.string().email(),
  password: z.string().min(8),
  username: z.string().min(3).optional(),
})

export const locationSchema = z.object({
  title: z.string().min(3),
  short_description: z.string().max(280).optional().or(z.literal('')),
  description: z.string().optional().or(z.literal('')),
  latitude: z.coerce.number().min(-90).max(90),
  longitude: z.coerce.number().min(-180).max(180),
  region_code: z.string().optional().or(z.literal('')),
  privacy_level: z.coerce.number().min(1).max(5),
  access_quality: z.coerce.number().min(1).max(5),
  scenery_level: z.coerce.number().min(1).max(5),
  warning_keys: z.array(z.string()).default([]),
})

export const reviewSchema = z.object({
  location: z.string().uuid(),
  recommendation_score: z.coerce.number().min(1).max(5),
  privacy_score: z.coerce.number().min(1).max(5),
  access_score: z.coerce.number().min(1).max(5),
  comment: z.string().optional().or(z.literal('')),
  visit_date: z.string().transform((v) => (v === '' ? null : v)).nullable().optional(),
})

export const detailReviewSchema = z.object({
  recommendation_score: z.coerce.number().min(1).max(5),
  privacy_score: z.coerce.number().min(1).max(5),
  access_score: z.coerce.number().min(1).max(5),
  comment: z.string().optional().or(z.literal('')),
  visit_date: z.string().transform((v) => (v === '' ? null : v)).nullable().optional(),
})

export const reportSchema = z.object({
  target_type: z.enum(['location', 'review']),
  target_id: z.string().min(1),
  reason: z.string().min(3),
  details: z.string().optional().or(z.literal('')),
})

export const detailReportSchema = z.object({
  target_type: z.enum(['location', 'review']),
  target_id: z.string().min(1),
  reason: z.string().min(3),
  details: z.string().optional().or(z.literal('')),
})
